// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "79db1e3c48d0c250ae33fc41dfb589f0" + ".css";
};